export default __webpack_public_path__ + "static/media/RemoveIcon.467b1779.svg";